import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { ExecutiveCommandCenter2 } from "@/components/admin/ExecutiveCommandCenter2";
import { SuperAdminPinGate } from "@/components/admin/SuperAdminPinGate";
import { requireSuperAdminGuard } from "@/lib/security/tenantIsolation";

export const Route = createFileRoute("/admin/executive-command-center")({
  beforeLoad: ({ location }) => { requireSuperAdminGuard(location.pathname); },
  head: () => ({
    meta: [
      { title: "Executive Command Center 2.0 · VerseSport™" },
      { name: "description", content: "Ad-Sync, Attention, Predictive Demand, Category Activation, Revenue & ROI." },
    ],
  }),
  component: () => (
    <SuperAdminPinGate>
      <div className="min-h-screen bg-background text-foreground">
        <header className="sticky top-0 z-30 border-b border-border/60 glass">
          <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3 md:px-6">
            <Link to="/admin" className="flex h-9 w-9 items-center justify-center rounded-lg glass hover:bg-accent" aria-label="Back">
              <ArrowLeft className="h-4 w-4" />
            </Link>
            <div>
              <div className="text-sm font-black tracking-tight">Executive Command Center 2.0</div>
              <div className="text-[10px] font-bold text-gradient-red tracking-widest">AD-SYNC · ATTENTION · ACTIVATION</div>
            </div>
          </div>
        </header>
        <main className="mx-auto max-w-7xl px-4 py-6 md:px-6">
          <ExecutiveCommandCenter2 />
        </main>
      </div>
    </SuperAdminPinGate>
  ),
});
